import RequestState from 'Enums/RequestState'
import IFFilterType from 'Enums/IFFilterType'

export const INITIAL_STATE = {
  tariffs: [],
  count: 0,
  tariffsPaginationOffset: 0,
  fetchTariffListRequestState: RequestState.UNINITIALIZED,
  createTariffRequestState: RequestState.UNINITIALIZED,
  updateTariffRequestState: RequestState.UNINITIALIZED,
  deleteTariffRequestState: RequestState.UNINITIALIZED,
  fetchTariffsCountRequestState: RequestState.UNINITIALIZED,
  tariffFilter: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.DATE_RANGE,
      title: 'Start Date',
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.DATE_RANGE,
      title: 'Expiry Date',
      initialValue: [],
      value: [],
    },
  ],
}
